/** @type {TemplatesConstructor} */
export function getMobileBody(constructors, state) {
    const { mElem, elem, mContactsElem } = constructors;
    const { i18n } = state;

    const templates = {};

    const defaultPopup = ({ services, url, copy }) => {
        const content = [mElem('popup-tile', services)];

        if (copy) {
            content.push(mElem('mobile-popup-copy-link', url));
        }

        return {
            content
        };
    };

    const popupWithContacts = ({ services, url, copy }) => {
        const content = [
            mElem('header', i18n.sendToMessenger),
            mElem('scroll-hider', elem('messenger-contacts')),
            mElem('header', i18n.shareButton),
            mElem('scroll-hider', mContactsElem('popup-tile-wrapper', services))
        ];

        if (copy) {
            content.push(mElem('mobile-popup-copy-link', url));
        }

        return {
            content
        };
    };

    // TODO Ð½Ð° Ð±ÑƒÐ´ÑƒÑ‰ÐµÐµ: Ð²Ñ‹Ð½ÐµÑÑ‚Ð¸ ÐºÐ°Ðº Ð¿Ð°Ñ‚Ñ‚ÐµÑ€Ð½ Ð¼ÐµÐ¼Ð¾Ð¸Ð·Ð°Ñ†Ð¸Ð¸ Ð²Ñ‹Ð·Ð¾Ð²Ð° ÑˆÐ°Ð±Ð»Ð¾Ð½Ð°
    const prevParams = {};

    templates['popup-body'] = params => {
        const mobilePopup = params.needExtendMessenger ? popupWithContacts : defaultPopup;
        return mobilePopup(Object.assign(prevParams, params));
    };

    return templates;
}
